import { Container, IconName, Stack, Typography } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TooltippedIcon } from '@mews-commander/ui';
import { CheckInConfigurationValue } from '@mews-commander/data-access';
import { getConfigurationValueTextKey } from '../utils';

interface StaticVisibilityFieldProps {
    tooltipValue: React.ReactNode;
    visibilityValue: CheckInConfigurationValue;
}

export const StaticVisibilityField = ({ tooltipValue, visibilityValue }: StaticVisibilityFieldProps) => (
    <Container width="100%" padding={['0', '100']}>
        <Stack itemAlignment="center" distribution="space-between">
            <Typography textStyle="bodyMedium" variant="secondary" as="span">
                <LocalizedText textKey={getConfigurationValueTextKey(visibilityValue)} />
            </Typography>
            <TooltippedIcon size="small" iconVariant="basic" value={IconName.Info} tooltip={tooltipValue} />
        </Stack>
    </Container>
);
